import { Component, OnInit } from "@angular/core";
import { Plugins } from "@capacitor/core";
const { SplashScreen } = Plugins;
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import {
  MenuController,
  PopoverController,
  NavController,
  Platform
} from "@ionic/angular";
import * as firebase from "firebase";
import * as firebaseui from "firebaseui";

import { PopOverComponent } from "./pop-over/pop-over.component";
import { Router } from "@angular/router";
import { AuthService } from "./services/auth.service";
import { Storage } from "@ionic/storage";
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: [
    "./side-menu/styles/side-menu.scss",
    "./side-menu/styles/side-menu.shell.scss",
    "./side-menu/styles/side-menu.responsive.scss"
  ]
})
export class AppComponent implements OnInit {
  collapseCard: boolean;
  collapseCardA: boolean;
  collapseCardB: boolean;
  collapseCardC: boolean;
  collapseCardD: boolean;
  collapseCardE: boolean;
  collapseCardF: boolean;
  collapseCardG: boolean;
  collapseAboutUs: boolean;
  collapseJoinUs: boolean;

  cate = [
    {
      subject: "STEM",
      url: "./assets/images/icons/icon_white/STEM icon.svg"
    },
    {
      subject: "學術",
      url: "./assets/images/icons/icon_white/學術 icon.svg"
    },
    {
      subject: "運動",
      url: "./assets/images/icons/icon_white/運動 icon.svg"
    },
    {
      subject: "藝術",
      url: "./assets/images/icons/icon_white/藝術 icon.svg"
    },
    {
      subject: "制服",
      url: "./assets/images/icons/icon_white/制服 icon.svg"
    },
    {
      subject: "技能",
      url: "./assets/images/icons/icon_white/技能 icon.svg"
    },
    {
      subject: "其他",
      url: "./assets/images/icons/icon_white/其他 icon.svg"
    }
  ];

  // contact us 聯絡我們
  // contactUsPages = [
  //   {
  //     title: "Profile",
  //     url: "/app/user",
  //     icon: "./assets/sample-icons/side-menu/profile.svg"
  //   },
  //   {
  //     title: "Contact Card",
  //     url: "/contact-card",
  //     icon: "./assets/sample-icons/side-menu/contact-card.svg"
  //   },
  //   {
  //     title: "Notifications",
  //     url: "/app/notifications",
  //     icon: "./assets/sample-icons/side-menu/notifications.svg"
  //   }
  // ];

  // join us 加入我們
  joinUsPages = [
    {
      title: "供應商",
      url: "/contact-us-submenu1"
      // icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "學校教職員",
      url: "/contact-us-submenu2"
      // icon: "./assets/sample-icons/side-menu/contact-card.svg"
    },
    {
      title: "銷售團隊",
      url: "/contact-us-submenu3"
      // icon: "./assets/sample-icons/side-menu/notifications.svg"
    }
  ];

  // about us 關於我們
  aboutUsPages = [
    {
      title: "報價程序",
      url: "/about-us-submenu1"
      // icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "為何選擇我們",
      url: "/about-us-submenu2"
      // icon: "./assets/sample-icons/side-menu/contact-card.svg"
    },
    {
      title: "合作夥伴",
      url: "/about-us-submenu3"
      // icon: "./assets/sample-icons/side-menu/notifications.svg"
    }
  ];

  // STEM
  cate_1_Pages = [
    {
      title: "Lego Education",
      url: "/firebase/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "Micro：bit",
      url: "/firebase/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "mBot",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "Scratch",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "Arduino",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "3D print",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "Dash and Dot",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "VR",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "種植項目",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    }
  ];

  // 學術
  cate_2_Pages = [
    {
      title: "中文",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "英文",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "數學",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "phonics",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "劍橋英語",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "奧數",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "珠心算",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "普通話",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "朗誦",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "辯論",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "書法",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "新來港學童廣東話班",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "日語",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "韓語",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "西班牙語",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "法語",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    }
  ];

  // 運動
  cate_3_Pages = [
    {
      title: "手球隊",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "足球隊",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "籃球隊",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "排球隊",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "乒乓球",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "羽毛球",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "田徑隊",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "跆拳道",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "空手道",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "柔道",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "足毽",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: " 游泳",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "水上活動",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "壁球",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "欖球",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "射箭",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "武術",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "閃避球",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "跳繩",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "武術",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "網球",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "體適能",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    },
    {
      title: "其他",
      url: "/app/user",
      icon: "./assets/sample-icons/side-menu/profile.svg"
    }
  ];

  // 藝術
  cate_4_Pages = [
    {
      title: "芭蕾舞",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "社交舞",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "街舞",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "K-Pop舞",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "現代舞",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "中國舞",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "爵士舞",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    },
    {
      title: "Hip - Hop舞",
      url: "/app/categories",
      icon: "./assets/sample-icons/side-menu/categories.svg"
    }
  ];

  accountPages = [
    {
      title: "Log In",
      url: "/auth/login",
      icon: "./assets/sample-icons/side-menu/login.svg"
    },
    {
      title: "Sign Up",
      url: "/auth/signup",
      icon: "./assets/sample-icons/side-menu/signup.svg"
    },
    {
      title: "About Us",
      url: "/pages/about-us",
      icon: "./assets/sample-icons/side-menu/tutorial.svg"
    },
    {
      title: "Join Us",
      url: "/pages/join-us",
      icon: "./assets/sample-icons/side-menu/getting-started.svg"
    },
    {
      title: "Contact Us",
      url: "/pages/contact-us",
      icon: "./assets/sample-icons/side-menu/warning.svg"
    },
    {
      title: "Tutorial",
      url: "/walkthrough",
      icon: "./assets/sample-icons/side-menu/tutorial.svg"
    },
    {
      title: "Getting Started",
      url: "/getting-started",
      icon: "./assets/sample-icons/side-menu/getting-started.svg"
    },
    {
      title: "404 page",
      url: "/page-not-found",
      icon: "./assets/sample-icons/side-menu/warning.svg"
    }
  ];

  textDir = "ltr";
  photoURL: string;
  displayName: string;
  signin: string;
  ui: firebaseui.auth.AuthUI;
  uid: string;
  email: string;
  isAnonymous: boolean;

  constructor(
    private authService: AuthService,
    private platform: Platform,
    public translate: TranslateService,
    private popoverController: PopoverController,
    private menu: MenuController,
    public router: Router,
    public navCtrl: NavController,
    private storage: Storage
  ) {
    // Initialize the FirebaseUI Widget using Firebase.
    // this.ui =
    //   firebaseui.auth.AuthUI.getInstance() ||
    //   new firebaseui.auth.AuthUI(firebase.auth());
    //    this.ui = new firebaseui.auth.AuthUI(firebase.auth());

    this.initializeApp();
    this.checkUserStatus();

    this.setLanguage();
  }

  async initializeApp() {
    // try {
    //   await SplashScreen.hide();
    // } catch (err) {
    //   console.log("This is normal in a browser", err);
    // }

    this.platform.ready().then(() => {
      // this.statusBar.styleDefault();
      SplashScreen.hide();
    });
  }

  setLanguage() {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang("en");

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use("en");

    // this is to determine the text direction depending on the selected language
    // for the purpose of this example we determine that only arabic and hebrew are RTL.
    // this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
    //   this.textDir = (event.lang === 'ar' || event.lang === 'iw') ? 'rtl' : 'ltr';
    // });
  }

  ionViewOnEnter() {
    console.log("app on enter");

    const userDetails = this.authService.userDetails();
    console.log(userDetails);

    this.checkUserStatus();
  }

  async onUserPage() {}
  // async presentPopover(ev: any) {
  //   const popover = await this.popoverController.create({
  //    component: PopOverComponent,
  //     event: ev,
  //     translucent: true
  //   });
  //   return await popover.present();
  // }

  ionViewDidLoad() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        console.log(user);
        this.uid = user.uid;
      } else {
        console.log("Not authenticated");
        // No user is signed in.
      }
    });
  }

  checkUserStatus() {
    firebase.auth().onAuthStateChanged(
      user => {
        if (user) {
          // User is signed in.
          const isAnonymous = user.isAnonymous;
          this.uid = user.uid;
          this.displayName = user.displayName;
          this.photoURL = user.photoURL;
          console.log(user, this.photoURL, this.displayName);
          const displayName = user.displayName;
          const email = user.email;
          const emailVerified = user.emailVerified;
          const photoURL = user.photoURL;
          const uid = user.uid;
          const phoneNumber = user.phoneNumber;
          const providerData = user.providerData;
          user.getIdToken().then(accessToken => {
            console.log("accessToken: ", accessToken);

            // document.getElementById("sign-in-status").textContent = "Signed in";
            // document.getElementById("sign-in").textContent = "Sign out";
            this.signin = "Sign out";
            this.isAnonymous = isAnonymous;
            this.displayName = displayName;
            this.uid = uid;
            this.email = email;
            this.photoURL = photoURL;
          });

          // this.navCtrl.navigateForward("/firebase/categories");
          this.navCtrl.navigateForward("/firebase/categories");
        } else {
          // User is signed out.
          // document.getElementById("sign-in-status").textContent = "Signed out";
          // document.getElementById("sign-in").textContent = "Sign in";
          this.signin = "Sign in";
          // document.getElementById("account-details").textContent = "null";
          //    this.navCtrl.navigateForward("/auth/signup");
        }
      },
      function(error) {
        console.log(error);
      }
    );
  }

  ngOnInit(): void {
    // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    // Add 'implements OnInit' to the class.
  }

  onDismiss() {
    this.menu.close();
    console.log("menu clicked");
  }

  onSignOut() {
    firebase.auth().onAuthStateChanged(
      user => {
        if (user) {
          // User is signed in.
          const isAnonymous = user.isAnonymous;
          this.uid = user.uid;
          this.displayName = user.displayName;
          this.photoURL = user.photoURL;
          console.log(user, isAnonymous);
          const displayName = user.displayName;
          const email = user.email;
          const emailVerified = user.emailVerified;
          const photoURL = user.photoURL;
          const uid = user.uid;
          const phoneNumber = user.phoneNumber;
          const providerData = user.providerData;
          user.getIdToken().then(accessToken => {
            console.log("accessToken: ", accessToken);

            // document.getElementById("sign-in-status").textContent = "Signed in";
            // document.getElementById("sign-in").textContent = "Sign out";
            this.signin = "Sign out";
            this.isAnonymous = isAnonymous;
            this.displayName = displayName;
            this.uid = uid;
            this.email = email;
            this.photoURL = photoURL;
          });

          firebase
            .auth()
            .signOut()
            .then(() => {
              this.storage.remove("firebaseui::rememberedAccounts");
              console.log("signed out");
              // User is signed out.
              // document.getElementById("sign-in-status").textContent =
              // "Signed out";
              // document.getElementById("sign-in").textContent = "Sign in";
              this.signin = "Sign in";
              // document.getElementById("account-details").textContent = "null";

              //      this.navCtrl.navigateForward("/app/auth/signup");
            })
            .catch(error => {});
        } else {
          // User is signed out.
          // document.getElementById("sign-in-status").textContent = "Signed out";
          // document.getElementById("sign-in").textContent = "Sign in";
          this.signin = "Sign in";
          // document.getElementById("account-details").textContent = "null";
          //    this.navCtrl.navigateForward("/auth/signup");
        }
      },
      function(error) {
        console.log(error);
      }
    );
  }

  doAnonymousSignup(): void {
    console.log("firebase anonymous sign up");

    firebase
      .auth()
      .signInAnonymously()
      .then(res => {
        console.log(res);
        this.navCtrl.navigateForward(["/firebase/real-estate"]);
        // this.router.navigate(["firebase/categories"]);
      })
      .catch(function(error) {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;

        console.log(errorCode, errorMessage);
      });
    // this.ui.start("#firebaseui-auth-container", {
    //   signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID]
    //   // Other config options...
    // });

    //    this.router.navigate(["app/categories"]);
  }

  hideTooltipbar() {
    console.log("hi");
    document.getElementById("tooltipbar").style.display = "none";
  }

  onCloseMenu() {
    this.menu.close();
  }
}
